import { useEffect } from "react";
import { useLocation } from "react-router";

import { useAnalytics } from "@btnet/utilities-analytics";

/**
 * Emits a `route_change` analytics event on every SPA navigation.
 */
export function AppRouteChange() {
    const location = useLocation();
    const { trackAnalytics } = useAnalytics();

    useEffect(() => {
        trackAnalytics({
            eventType: "route_change",
            eventName: "route_change",
            referrerUrl: document.referrer || null,
        });
    }, [location.pathname, trackAnalytics]);

    return null;
}
